<template>
    <div v-if="template.template_context === 'mailchimp'">
        <v-data-table
            :headers="headers"
            :items="mailchimp_campaigns"
            :items-per-page="100"
            class="elevation-1"
            :hide-default-footer="true"
            :footer-props="{
                disableItemsPerPage: false,
                disablePagination: false,
            }"
            no-data-text="You have not selected any mailchimp campaigns.  Use the (+) button below to add a mailchimp campaign"
            disable-sort
        >

            <template #item.action="{ item }">
                <v-menu bottom offset-y>
                    <template #activator="{ on }">
                        <v-icon v-on="on">
                            mdi-dots-vertical
                        </v-icon>
                    </template>

                    <v-list>
                        <v-list-item :disabled="read_only" @click="onClickRemoveCampaign(item.value)">
                            <v-list-item-title>Remove</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>

        </v-data-table>

        <m-icon-bar
            v-if="!read_only"
            @add="onClickAddCampaign"
        />

        <m-auto-message-add-crm-email-dailog
            ref="auto-message-add-crm-email-dailog"
            content_type="mailchimp"
            @input="onAddCampaignId"
        />

        <v-select
            label="Mailchimp Event (Type) (Required)"
            :items="$rc.enumChoices('crm_email_event_type',false)"
            :value="template.email_event_triggers"
            :disabled="read_only"
            multiple
            @input="onUpdateEventTriggers"
        />

        <p>
            <strong>Note</strong> Mailchimp does not always record and report events in real time. Delays of up to an hour from the event to the report have been observed. Average delay observed is 14 minutes 17 seconds.
        </p>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true
        },
        mailchimp_campaigns: {
            type: Array,
            default: () => []
        },
        read_only: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            headers: [
                { text: 'Campaign Id', value: 'value'},
                { text: 'Mailchimp Campaign', value: 'text'},
                { text: 'Action', value: 'action'},
            ]
        }
    },

    methods: {
        onClickAddCampaign() {
            this.$refs['auto-message-add-crm-email-dailog'].showDialog();
        },

        onAddCampaignId(emailCampaignId) {
            this.$emit('add-campaign', emailCampaignId);
        },

        onClickRemoveCampaign(emailCampaignId) {
            this.$emit('remove-campaign', emailCampaignId);
        },

        onUpdateEventTriggers(value) {
            this.$emit('update:emailEventTriggers', value);
        }
    }
}
</script>
